import { runStartupTask } from "./startupTask";

export class SessionReconciliationSupersededError extends Error {
  constructor() { super("Session changed during reconciliation"); }
}

/** Technische Fehler bleiben Fehler; nur eine bestätigte 401 verwirft die Sitzung. */
export async function reconcileSession<T>(adapter: {
  revision: () => unknown;
  load: (signal: AbortSignal) => Promise<T>;
  apply: (value: T) => void;
  clear: () => void;
  isUnauthorized: (error: unknown) => boolean;
  /** Manche API-Clients löschen bei 401 bereits synchron ihren Profilcache. */
  isCleared?: () => boolean;
  reportError?: (error: unknown) => void;
}, signal: AbortSignal = AbortSignal.timeout(15_000)): Promise<void> {
  const revision = adapter.revision();
  try {
    const value = await runStartupTask(signal => adapter.load(signal), signal);
    signal.throwIfAborted();
    if (revision !== adapter.revision()) throw new SessionReconciliationSupersededError();
    adapter.apply(value);
  } catch (error) {
    // Ein alter Versuch darf auch nach Timeout/Unmount keine Sitzung abmelden.
    signal.throwIfAborted();
    const unauthorized = adapter.isUnauthorized(error);
    if (revision !== adapter.revision() && !(unauthorized && adapter.isCleared?.())) throw new SessionReconciliationSupersededError();
    if (!unauthorized) {
      adapter.reportError?.(error);
      throw error;
    }
    adapter.clear();
  }
}
